// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__svFl0","modal":"styles_modal__EKiUC","header":"styles_header__0BEle","title":"styles_title__HjadP","description":"styles_description__1Gia6"};